import HfReactHelper from 'js/sign-components/common/hf-react-helper';
import { initializeDebugTraceKey } from 'js/sign-components/common/debug-trace-key';
import { initializeAnalyticsConsentHandling } from 'js/sign-components/common/product-analytics-pipeline';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Validation from 'signer-app/signer-experience/signer-validation-constants';
import '../../scss/style.scss';
import 'common/utils/log-uncaught-promises';
import 'common/logger/track-logger';
import configureRaven from '../common/utils/sentry';
import components from './components';
import Application, { phpComponents } from './application';

// for server-side rendering (lib/vendor/react-server) (CC)
global.Application = Application;
global.app = new Application();

// Accessing 'window' breaks node.js server-side rendering.
// We MUST use 'typeof' to check for its existence. -Chris
if (typeof window !== 'undefined') {
  initializeAnalyticsConsentHandling();
  window.app = global.app;
}

global.HfReactHelper = HfReactHelper;
global.PHPComponents = phpComponents;
global.Validation = Validation;
global.React = React;
global.ReactDOM = ReactDOM;

// Initialize debug trace key before Sentry configuration
initializeDebugTraceKey();

// Adding Sentry Raven for error logging
configureRaven({});

// hack to expose HS components to the react server (CC)
global.HSComponents = components;
